 /*
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('img:not([loading]):not(.no-lazy)').forEach(function(img) {
   img.setAttribute('loading', 'lazy');
 });
 });*/
 
document.addEventListener("DOMContentLoaded", function () {
  // Lazify only imgs that don't already declare loading, aren't high-priority, and aren't opted out
  document
    .querySelectorAll('img:not([loading]):not([fetchpriority="high"]):not(.no-lazy)')
    .forEach(img => img.setAttribute('loading', 'lazy'));

  // Hard guard: any high-priority images should be eager and NOT lazy-loaded by libraries
  document.querySelectorAll('img[fetchpriority="high"]').forEach(img => {
    img.setAttribute('loading','eager');
    img.classList.remove('lazyload');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  });

  // OPTIONAL: handle images injected later (sliders, theme sections, etc.)
  const applyRules = (img) => {
    if (!img || img.tagName !== 'IMG') return;
    if (img.getAttribute('fetchpriority') === 'high') {
      img.setAttribute('loading','eager');
      img.classList.remove('lazyload');
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
    } else if (!img.hasAttribute('loading') && !img.classList.contains('no-lazy')) {
      img.setAttribute('loading','lazy');
    }
  };
  const mo = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.tagName === 'IMG') applyRules(node);
          node.querySelectorAll && node.querySelectorAll('img').forEach(applyRules);
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
});



